'use client';

import { c as _c } from "react/compiler-runtime";
import { CalendarClock, CreditCard, Eye, PenLine, ShieldCheck, Sparkles } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { Pill, PreviewWindow } from '@/app/onboarding/_components/workspace-setup/previews/preview-frame';
import { useTicker } from '@/app/onboarding/_components/workspace-setup/previews/use-ticker';
const EVENTS = [{
  icon: PenLine,
  title: 'Jordan Lee signed',
  detail: 'Purchase agreement · 123 Main St'
}, {
  icon: CreditCard,
  title: 'Earnest money received',
  detail: '$5,000 · held until closing'
}, {
  icon: ShieldCheck,
  title: 'Compliance review passed',
  detail: '88 Oak Ave · audit trail saved'
}, {
  icon: Sparkles,
  title: 'Clai drafted a counteroffer',
  detail: 'Ready for your review'
}, {
  icon: CalendarClock,
  title: 'Inspection moved to Friday',
  detail: 'Everyone on the deal was notified'
}, {
  icon: Eye,
  title: 'Priya Patel opened the disclosure',
  detail: 'Seller disclosure · 2 min ago'
}] as const;

/** Fewer than EVENTS, so a row's key never repeats. */
const VISIBLE_ROWS = 4;

/** Deal updates arriving one by one in a live feed. */
export function ActivityFeedPreview() {
  const $ = _c(4);
  const tick = useTicker(EVENTS.length, 1300);
  let t0;
  if ($[0] !== tick) {
    t0 = Array.from({
      length: VISIBLE_ROWS
    }, (_, age) => (tick - age + EVENTS.length) % EVENTS.length);
    $[0] = tick;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const rows = t0;
  let t1;
  if ($[2] !== rows) {
    t1 = <PreviewWindow title="While you were away" data-sentry-element="PreviewWindow" data-sentry-component="ActivityFeedPreview" data-sentry-source-file="activity-feed-preview.tsx"><ul className="space-y-2"><AnimatePresence initial={false} mode="popLayout" data-sentry-element="AnimatePresence" data-sentry-source-file="activity-feed-preview.tsx">{rows.map(_temp)}</AnimatePresence></ul></PreviewWindow>;
    $[2] = rows;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(eventIndex, age_0) {
  const event = EVENTS[eventIndex];
  if (!event) {
    return null;
  }
  return <motion.li key={eventIndex} layout={true} className="border-border bg-card flex items-center gap-3 rounded-xl border px-3 py-2.5" initial={{
    opacity: 0,
    y: -16,
    scale: 0.95
  }} animate={{
    opacity: 1 - age_0 * 0.18,
    y: 0,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 0.9
  }} transition={{
    type: "spring",
    stiffness: 320,
    damping: 28
  }}><span className="bg-primary/10 text-primary flex size-8 shrink-0 items-center justify-center rounded-full"><event.icon className="size-4" /></span><span className="min-w-0 flex-1 text-left"><span className="text-foreground block truncate text-sm font-medium">{event.title}</span><span className="text-muted-foreground block truncate text-xs">{event.detail}</span></span>{age_0 === 0 ? <Pill tone="green">New</Pill> : null}</motion.li>;
}